import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.match";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/b-1ce38705e8d749ebacb1574ceae41f8a/codebase/pages/jueji/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import env from '@tencent/vft-common/env';
import login from '@tencent/vft-common/login';
import cookie from '@tencent/vft-common/cookie';
import openApp from '@tencent/vft-common/openapp';
import atom from '@tencent/vft-atom';
import Clipboard from '@tencent/vft-common/clipboard';
import { request } from '@tencent/vft-common/request';
import * as report from './report'; // 能登录微信

var wxloginWhiteList = ['app', 'wechat', 'weishi'];

var _instance;

var _cacheWhiteList;

export default {
  data: function data() {
    return {
      appName: '腾讯视频',
      visible: false,
      // 是否显示登录弹窗
      state: false,
      // 登录完成后的跳转地址
      desc: '',
      // 副标题展示
      jumpUrl: '',
      // 登录完成后的跳转地址
      pageUrl: location.href,
      // 页面地址
      isLogin: false,
      // 是否已登录
      isLoginExpired: false,
      // 登录态已过期
      loginType: '',
      // 当前登录类型
      canLoginQQ: !env.isMqq,
      // 能否登录QQ
      canLoginWechat: env.isApp,
      // 能否登录微信
      canOpenApp: false,
      // 能否拉起腾讯视频
      inWxMiniApp: false,
      // 是否在微信小程序内
      env: env.app,
      // 当前环境，wechat
      forceReload: true // 页面回退时，是否强制刷新页面

    };
  },
  created: function created() {
    if (env.isWechat && (!window.WeixinJSBridge || !WeixinJSBridge.invoke)) {
      document.addEventListener('WeixinJSBridgeReady', this.init.bind(this), false);
    } else {
      this.init();
    }
  },
  mounted: function mounted() {
    var _this = this;

    _instance = this; // fix 微信切换到登录界面时，手动返回页面由于页面 cache 导致页面无刷新问题

    window.addEventListener('pageshow', function (event) {
      if (event && event.persisted) {
        // 通过 foceReload=false 避免页面回退的时候，强制刷新
        // 业务可通过注册 reinit 方法，可在回退的时候触发页面异步刷新数据
        if (_this.forceReload) {
          window.location.reload();
        } else if (typeof window.reinit === 'function') {
          window.reinit();
        }
      }
    });
  },
  methods: {
    init: function init() {
      var _this2 = this;

      login.init(function () {
        _this2.isLogin = login.isLogin();
        _this2.loginType = login.loginType();

        _this2.setEnv();
      });
    },

    /**
     * 更新状态
     */
    updateState: function updateState(callback) {
      var _this3 = this;

      var timer = setTimeout(function () {
        callback();
      }, 300);
      login.onInit( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var isStrictLogin;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                isStrictLogin = login.isLogin();

                if (isStrictLogin && login.loginType() === 'qq' && cookie.get('uin') && !cookie.get('skey')) {
                  isStrictLogin = false;
                }

                _context.next = 4;
                return _this3.setEnv();

              case 4:
                clearTimeout(timer);
                _this3.isLogin = login.isLogin();
                _this3.isLoginExpired = !!(!isStrictLogin && login.isLogin());
                _this3.loginType = login.loginType(); // 能登录微信

                if (_this3.env === 'wechat' && _this3.loginType === 'wx' && !_this3.isLoginExpired) {
                  _this3.canLoginWechat = false;
                }

                if (typeof callback === 'function') {
                  callback();
                }

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },

    /**
     * 设置环境
     */
    setEnv: function setEnv() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var appLaunchWhiteList, whiteList, ua, i, len, app, j, _len, conf;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = openApp.canGetInstallState;

                if (!_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return openApp.getInstallState();

              case 4:
                _context2.t0 = !_context2.sent;

              case 5:
                if (!_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _this4.canOpenApp = false;

              case 7:
                _this4.inWxMiniApp = window.__wxjs_environment && window.__wxjs_environment === 'miniprogram';
                _this4.canLoginQQ = !env.isMqq && !_this4.inWxMiniApp;

                if (_this4.env === 'wechat' && _this4.loginType !== 'wx' || wxloginWhiteList.indexOf(_this4.env) > -1) {
                  _this4.canLoginWechat = true;
                } // 能拉起腾讯视频


                appLaunchWhiteList = ['wechat', 'mqq', 'app', 'qqbrowser'];

                if (appLaunchWhiteList.indexOf(_this4.env) > -1) {
                  _this4.canOpenApp = true;
                }

                if (!(!env.isApp && !env.isMqq && !env.isWechat)) {
                  _context2.next = 35;
                  break;
                }

                _context2.next = 15;
                return _this4.requestWhiteList();

              case 15:
                whiteList = _context2.sent;
                ua = navigator.userAgent;
                i = 0, len = whiteList.length;

              case 18:
                if (!(i < len)) {
                  _context2.next = 35;
                  break;
                }

                app = whiteList[i];

                if (!(app.ua && app.ua.length > 0)) {
                  _context2.next = 32;
                  break;
                }

                j = 0, _len = app.ua.length;

              case 22:
                if (!(j < _len)) {
                  _context2.next = 32;
                  break;
                }

                conf = app.ua[j];

                if (!(conf && ua.match(new RegExp(conf.rule, 'i')))) {
                  _context2.next = 29;
                  break;
                }

                _this4.canLoginWechat = app.enableWechatLogin;
                _this4.canLoginQQ = app.enableQQLogin;
                _this4.canOpenApp = app.enableOpenApp;
                return _context2.abrupt("break", 32);

              case 29:
                j++;
                _context2.next = 22;
                break;

              case 32:
                i++;
                _context2.next = 18;
                break;

              case 35:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    requestWhiteList: function requestWhiteList() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", new Promise(function (resolve) {
                  if (_cacheWhiteList) {
                    return resolve(_cacheWhiteList);
                  }

                  _this5._wujiRequest().then(function (res) {
                    if (res && $.isArray(res.data) && res.data.length > 0) {
                      _cacheWhiteList = res.data;
                      return resolve(res.data);
                    }

                    resolve([]);
                  }).catch(function () {
                    resolve([]);
                  });
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    _wujiRequest: function _wujiRequest() {
      if (window._dataPreload && window._dataPreload['LoginPanel']) {
        return Promise.resolve(window._dataPreload['LoginPanel']);
      }

      return request('//wuji.video.qq.com/fcgi-bin/wuji?appid=1000433&appkey=589c3a3c6f7f406ab7202fcd5fcc9b8b&link=1', {
        link_query: 'include=rule'
      });
    },
    popup: function popup() {
      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (param) {
        this.jumpUrl = param.jumpUrl ? param.jumpUrl : '';
        this.onLogin = param.onLogin;
        this.desc = param.desc || '';

        if (param.isLoginExpired) {
          this.isLogin = false;
          this.isLoginExpired = true;
        }
      }

      this.visible = true;
      report.expose({
        f_module: this.isLogin ? '切换登录' : '登录',
        f_type: 0
      });
      this.doReport('expose', 'qq');
      this.doReport('expose', 'wx');
    },
    hide: function hide() {
      this.visible = false;
    },
    actionLogin: function actionLogin(type) {
      this.doReport('click', type);
      if (type === 'qq' && env.isMqq || type === 'wx' && env.isWechat && !this.canLoginWechat) return;

      if (type === 'wx' && !this.canLoginWechat || type === 'qq' && !this.canLoginQQ) {
        if (this.canOpenApp && !this.inWxMiniApp) {
          this.launchApp();
        } else if (type === 'wx' && !env.isWechat || type === 'qq' && !env.isMqq) {
          this.clipboard();
        }
      } else if (this.env !== 'mqq') {
        var param = {
          type: type
        };

        if (this.jumpUrl) {
          param.url = this.jumpUrl;
        }

        this.switchLogin(param);
      }
    },
    switchLogin: function switchLogin() {
      var _this6 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (typeof param.onLogin === 'function') {
        this.onLogin = param.onLogin;
      }

      if (param.jumpUrl) {
        this.jumpUrl = param.jumpUrl;
      }

      if (param.type === 'wx' && !this.canLoginWechat) {
        this.visible = true;
      } else {
        var isCallbacked = false;

        var _onLogin = function _onLogin(response) {
          if (!isCallbacked) {
            // 避免重复调用
            setTimeout(function () {
              isCallbacked = true;

              _this6.onSuccessLogin(param, response);

              atom.hideLoading();
            }, 500);
          }
        };

        if (env.isApp) {
          // 包括 phone 和 pad
          atom.once('onActionLoginFinish', _onLogin);
        }

        if (env.isWeishi) {
          this.doLoginWeishi().then(function (isLogin) {
            _onLogin({
              result: {
                isLogin: isLogin
              },
              errCode: 0
            });
          });
        } else if (env.isApp && atom.switchLogin) {
          atom.showLoading('正在登录', {
            timeout: 5000
          });
          atom.switchLogin(param.type).then(function (res) {
            if (!env.isAndroid) {
              _onLogin(res);
            }
          });
          atom.once('onSwitchLoginStateResponse', function (res) {
            if (res && res.result && res.result.switchResult) {
              _onLogin(res);
            }
          });
        } else {
          login.openLogin(param);
        }

        this.hide();
      }
    },
    delay: function delay() {
      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
      return new Promise(function (resolve) {
        setTimeout(resolve, timeout);
      });
    },
    // 在微视APP内，使用APP登录组件
    doLoginWeishi: function doLoginWeishi() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (window.WeishiBridge) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 3;
                return import(
                /* webpackChunkName: "weishi" */
                '@tencent/halo-jsbridge-weishi');

              case 3:
                window.WeishiBridge = _context4.sent;

              case 4:
                _context4.prev = 4;

                if (!(cookie.get('openid') || env.isIphone)) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 8;
                return window.WeishiBridge.call('weishi.logout');

              case 8:
                if (!env.isAndroid) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 11;
                return _this7.delay(100);

              case 11:
                _context4.next = 16;
                break;

              case 13:
                _context4.prev = 13;
                _context4.t0 = _context4["catch"](4);
                console.error('weishi.logout', _context4.t0);

              case 16:
                _context4.prev = 16;
                _context4.next = 19;
                return window.WeishiBridge.login({
                  doLogin: true
                });

              case 19:
                return _context4.abrupt("return", true);

              case 22:
                _context4.prev = 22;
                _context4.t1 = _context4["catch"](16);
                console.error('weishi.login', _context4.t1);

              case 25:
                return _context4.abrupt("return", false);

              case 26:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[4, 13], [16, 22]]);
      }))();
    },
    launchApp: function launchApp() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var schemeUrl;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                schemeUrl = "tenvideo2://?action=10&openurl=".concat(encodeURIComponent(_this8.pageUrl));

                if (_this8.pageUrl.match(/^(tenvideo2|txvideo):\/\//)) {
                  schemeUrl = _this8.pageUrl;
                }

                _this8.hide();

                _context5.next = 5;
                return openApp.launch(schemeUrl);

              case 5:
                if (_context5.sent) {
                  _context5.next = 7;
                  break;
                }

                // 拉起失败
                location.href = "https://film.qq.com/h5/app/openapp.html?openurl=".concat(encodeURIComponent(_this8.pageUrl), "&auto=0");

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    clipboard: function clipboard() {
      // eslint-disable-next-line
      new Clipboard({
        text: this.pageUrl || location.href,
        success: function success() {
          atom.toast('已复制链接');
        },
        error: function error() {
          atom.toast('暂不支持复制功能，可手动分享此页面到微信打开或者直接复制该页面地址！');
        }
      });
      this.hide();
    },
    onSuccessLogin: function onSuccessLogin(param, res) {
      if ((env.isApp || env.isWeishi) && typeof this.onLogin === 'function') {
        var result = res && res.result && res.errCode === 0 ? res.result : null;
        this.onLogin(result);
      } else if (param.url) {
        // 修改化定义的跳转地址
        location.href = param.url;
      } else if (typeof window.reinit === 'function') {
        // 调用全局注册的 reinit 方法
        window.reinit();
      } else {
        // 刷新当前页面
        location.reload();
      }
    },
    doReport: function doReport() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'expose';
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'qq';
      var loginType = type === 'qq' ? 'QQ' : '微信';
      var actionType = this.isLogin ? '切换' : '登录';
      var params = {
        f_module: this.isLogin ? '切换登录' : '登录',
        f_resource: "".concat(loginType).concat(actionType, "\u6309\u94AE"),
        f_type: 4
      };

      if (!env.isApp && (type === 'qq' && !this.canLoginQQ || type === 'wx' && !this.canLoginWechat)) {
        if (type === 'qq' && env.isMqq || type === 'wx' && env.isWechat) {
          params.f_resource = "".concat(loginType, "\u65E0\u6CD5").concat(actionType, "\uFF08").concat(env.isMqq ? 'QQ' : '微信', "\u5185\uFF09");
        } else if (this.canOpenApp) {
          params.f_resource = "".concat(loginType, "\u65E0\u6CD5").concat(actionType, "\uFF0C\u62C9\u817E\u8BAF\u89C6\u9891\u6309\u94AE");
        } else {
          params.f_resource = "".concat(loginType, "\u65E0\u6CD5").concat(actionType, "\uFF0C\u590D\u5236\u94FE\u63A5\u6309\u94AE");
        }
      }

      report[event](params);
    }
  },
  install: function install(Vue) {
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    for (var key in option) {
      if (_instance.hasOwnProperty(key) && option[key]) {
        _instance[key] = option[key];
      }
    }

    Vue.prototype.$openLogin = function (param) {
      _instance.updateState(function () {
        if (env.isWeishi) {
          _instance.switchLogin(param);
        } else {
          _instance.popup(param);
        }
      });
    };

    Vue.prototype.$switchLogin = function (param) {
      _instance.updateState(function () {
        _instance.switchLogin(param);
      });
    };

    Vue.prototype.$checkLogin = function (param) {
      return new Promise(function (resolve) {
        login.isStrictLogin(function (isLogin) {
          if (isLogin) {
            resolve(true);
          } else {
            resolve(false);

            _instance.updateState(function () {
              _instance.isLoginExpired = login.isLogin() && !isLogin;
              _instance.isLogin = login.isLogin();

              _instance.popup(param);
            });
          }
        });
      });
    };
  }
};